/**
 * Route error (SHELL-006).
 *
 * Rendered by the per-route `ErrorBoundary` in App.tsx in place of a screen
 * that threw while rendering or mounting. Unlike `BootError`, everything
 * outside this screen -- the `<main>` landmark, the router, the skip link --
 * is untouched: the boundary sits inside the matched route, not around it, so
 * only the screen that failed is replaced. `Screen` is safe to use here for
 * that reason.
 */
import { Screen } from '@shell/Screen';
import { routes } from '@shell/routes';

export function RouteError() {
  return (
    <Screen title="Something went wrong">
      <p>This screen ran into a problem and could not be shown.</p>
      <nav class="screen-nav">
        <a class="nav-link" href={routes.picker()}>
          Back to the game picker
        </a>
      </nav>
    </Screen>
  );
}
